import { useEffect } from "react";

import { useNavigate } from "react-router-dom";

import { alertDialog } from "shared/ui/feedback";

/**
 * 미로그인 상태로 관리자 경로에 접근했을 때의 가드.
 * "로그인이 필요합니다" 안내를 띄운 뒤 로그인 페이지로 이동시킨다.
 * (안내 모달은 GlobalAlertProvider가 라우트 상위에서 렌더하므로 이동 후에도 유지된다.)
 */
function RequireLogin() {
  const navigate = useNavigate();

  useEffect(() => {
    alertDialog("로그인이 필요합니다.");
    navigate("/login", { replace: true });
  }, [navigate]);

  return null;
}

export default RequireLogin;
